/**
 * @ngdoc    component
 * @module   csm.ui.fields
 * @name     csm.ui.fields.component:styledRadio
 * @property {String}  name     Group name.
 * @property {Object}  ngModel  Model to update.
 * @property {Object}  ngValue  Model value when selected.
 * @description
 * Stylized radio button replaces the default button with a styled SPAN. Taken
 * largely from <https://www.w3schools.com/howto/howto_css_custom_checkbox.asp>.
 *******************************************************************************/
export const styledRadioComponent = {
  bindings: {
    label: '@',
    name: '@',
    model: '=ngModel',
    value: '=ngValue',
    disabled: '=ngDisabled'
  },
  require: 'ngModel',
  transclude: true,
  template:
    '<label ng-style="!!$ctrl.disabled ? {cursor:\'default\'} : null"><ng-transclude></ng-transclude>' +
    '<input type="radio" ' +
    'name="{{$ctrl.name}}" ' +
    'ng-model="$ctrl.model" ' +
    'ng-value="$ctrl.value" ' +
    'ng-disabled="$ctrl.disabled" ' +
    'ng-change="$ctrl.ngModel.$setViewValue($ctrl.model)"/><span ng-disabled="$ctrl.disabled"></span>' +
    '</label>'
};
